import moment from 'moment'
import { Select } from '@driftt/tide-core-legacy'
import { GenerateSelectOptions } from './RowGenerator'

const PriorityInput = (playbook, playbookSizes, onChange) => {
  const offset = (playbookSizes.totalOutboundPlaybooks + playbookSizes.totalABMPlaybooks) + 1
  const priorityList = GenerateSelectOptions(offset, playbookSizes.totalNonSpecialPlaybooks)

  const changePriority = (e) => {
    onChange(e, playbook)
  }

  return (
    <div>
      <Select value={(playbook.priority)} 
              options={priorityList} 
              onChange={changePriority} 
              clearable={false} 
              className="set-priorities-select"
      />
    </div>
  )
}

const NameCell = playbook => (
  <div className="playbook-priority-list-name-cell">
    <div className="playbook-priority-list-name">
      {playbook.name}
    </div>
  </div>
)

const LastUpdated = (playbook, orgUsers) => {
  const lastUpdatedBy = orgUsers.get(playbook.updatedAuthorId || playbook.createdAuthorId)
  return (
    <div className="playbook-table-row-updated">
      <div>
        {moment(playbook.updatedAt).format('ll')}
      </div>
      {lastUpdatedBy &&
        <div className="playbook-table-row-last-update-by">by {(lastUpdatedBy.name || lastUpdatedBy.email)}</div>
      }
    </div>
  )
}

export const NonSpecialRowFormatter = (playbook, playbookSizes, onPriorityChange, orgUsers) => ([
  { content: PriorityInput(playbook, playbookSizes, onPriorityChange) },
  { content: NameCell(playbook) },
  { content: LastUpdated(playbook, orgUsers) }
])



// WEBPACK FOOTER //
// ./src/scripts/components/PlaybookList/Prioritize/PlaybookPrioritiesTable/NonSpecialRowFormatter.js